module.exports = __webpack_public_path__ + "static/media/focus.47f950e0.png";